<template>
  <div class="pill-col">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PillColumn'
};
</script>>
